const DesktopProductSkeleton = () => (
  <div className="hidden md:block">
    <div className="bg-white border border-slate-200 hover:border-slate-300 transition-all duration-200">
      <div className="grid grid-cols-12 items-center px-8 py-6 gap-6">
        {/* Product Name */}
        <div className="col-span-3">
          <div className="h-5 bg-gradient-to-r from-slate-200 to-slate-100 rounded-lg animate-pulse mb-2"></div>
          <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-100 rounded-lg animate-pulse w-3/4"></div>
        </div>

        {/* Status */}
        <div className="col-span-1 text-center">
          <div className="w-20 h-7 bg-gradient-to-r from-slate-200 to-slate-100 rounded-full animate-pulse mx-auto"></div>
        </div>

        {/* Brand Videos */}
        <div className="col-span-2 text-center">
          <div className="bg-slate-50 rounded-lg p-3 mx-auto w-16">
            <div className="w-8 h-4 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse mx-auto mb-1"></div>
            <div className="w-10 h-3 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse mx-auto"></div>
          </div>
        </div>

        {/* Competitor Videos */}
        <div className="col-span-2 text-center">
          <div className="bg-slate-50 rounded-lg p-3 mx-auto w-16">
            <div className="w-8 h-4 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse mx-auto mb-1"></div>
            <div className="w-12 h-3 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse mx-auto"></div>
          </div>
        </div>

        {/* Updated At */}
        <div className="col-span-2 text-center">
          <div className="flex items-center justify-center">
            <div className="w-4 h-4 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse mr-2"></div>
            <div className="w-24 h-4 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Action button */}
        <div className="col-span-2 text-right">
          <div className="w-32 h-10 bg-gradient-to-r from-slate-200 to-slate-100 rounded-lg animate-pulse ml-auto"></div>
        </div>
      </div>
    </div>
  </div>
);

export default DesktopProductSkeleton;
